import { createReducer, on } from "@ngrx/store";
import { IAppState } from "../../models/app.model";
import { IReqGenerateKeyRes } from "../../models/request-genearate-key.model";
import {
  clearStoreActiveStatus,
  updateActiveStatus,
  updateActiveStatusFailure,
  updateActiveStatusSuccess,
} from "./active-status.action";

export type UpdateUserActiveState = IAppState<IReqGenerateKeyRes>;

export const initialState: UpdateUserActiveState = {
  data: null,
  isLoading: false,
  error: null,
};

export const UserActiveStatusReducer = createReducer(
  initialState,
  on(
    updateActiveStatus,
    (state): UpdateUserActiveState => ({
      ...state,
      isLoading: true,
      error: null,
      data: null,
    })
  ),
  on(
    updateActiveStatusSuccess,
    (state, { response }): UpdateUserActiveState => ({
      ...state,
      isLoading: false,
      data: response,
      error: null,
    })
  ),
  on(
    updateActiveStatusFailure,
    (state, { error }): UpdateUserActiveState => ({
      ...state,
      isLoading: false,
      data: null,
      error,
    })
  ),
  on(clearStoreActiveStatus, (store) => ({ ...initialState }))

);
